import { setValueInStorage } from "~/hooks/localStorageHelpers";
export const GetTargetDiscoverySetupKey = (spaceId: string, projectSlug: string) => `Octopus.Project.${spaceId}.${projectSlug}.TargetDiscovery.Confirmed`;
export const ConfirmTargetDiscoverySetup = (spaceId: string, projectSlug: string) => {
    setValueInStorage(GetTargetDiscoverySetupKey(spaceId, projectSlug), "true");
};
